import { useTranslation } from "react-i18next"
import { Box } from "@chakra-ui/react"
import InfoItem from "../../common/InfoItem"
import { DateTime } from "luxon"
import { colors } from "../../../utilities/colors"

export default function TransferChangeRequest({ transfer }) {
  const { t } = useTranslation()
  const transferChangeRequest = transfer?.attributes['transfer-change-request'].data.attributes

  const statusColor = () => {
    switch (transferChangeRequest.status) {
      case 'Approved':
        return colors.green
      case 'Denied':
        return colors.fpxRed
      case 'Pending':
        return colors.yellow
    }
  }
  return (
    <Box>
      <Box width={'36'}>
        <Box
          display={'flex'}
          justifyContent={'center'}
          bg={'gray.900'}
          color={statusColor()}
          border={'1px solid'}
          fontSize={'xs'}
          m={'1'}
          py={'0.5'}
          borderRadius={'md'}
          data-testid='transfer-change-request-pill'
        >
          {t(`Reschedule ${transferChangeRequest['status']}`)}
        </Box>
      </Box>
      {
        transferChangeRequest.status === 'Pending' &&
        <InfoItem title={t('Requested Date')}>
          {
            DateTime.fromISO(
              transferChangeRequest['requested-date']
            ).toFormat('M/d/yy')
          }
        </InfoItem>
      }
    </Box>
  )
}